import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import confetti from 'canvas-confetti';
import { Button } from './ui/button';

const MASCOT = 'https://static.prod-images.emergentagent.com/jobs/75765fb2-f934-4a78-b9d4-83c5dd8dbc83/images/af05521cdbf5dee58e32af61f09c6d9408039100be1a7125afbc92f0d3489591.jpeg';

export const GoalCelebration = ({ goal, onClose }) => {
  useEffect(() => {
    if (!goal) return;
    confetti({
      particleCount: 60, spread: 70, startVelocity: 25, gravity: 0.6, ticks: 220,
      origin: { y: 0.45 }, colors: ['#E16246', '#F5D5CB', '#1A1A1A', '#EEEAE0'], scalar: 0.9,
    });
  }, [goal]);

  return (
    <AnimatePresence>
      {goal && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#FAF9F5]/85 backdrop-blur-md p-6"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onClick={onClose}
          data-testid="goal-celebration"
        >
          <motion.div
            className="max-w-sm w-full text-center"
            initial={{ y: 24, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
          >
            <motion.img
              src={MASCOT} alt=""
              className="w-36 h-36 mx-auto rounded-3xl object-contain"
              animate={{ y: [0, -8, 0] }}
              transition={{ duration: 3.5, repeat: Infinity, ease: 'easeInOut' }}
            />
            <p className="sl-section-tag mt-8 mb-3">GOAL COMPLETE</p>
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-[-0.03em] text-[#1A1A1A] leading-tight" data-testid="goal-celebration-title">
              {goal.title}
            </h2>
            <p className="mt-4 text-[#5F5F5F]">You kept your word. Take a breath — this one is yours.</p>
            <Button onClick={onClose} className="sl-pill-dark h-auto mt-8" data-testid="goal-celebration-close-btn">
              Continue
            </Button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
